import toast from "react-hot-toast";
import {
    GET_DAY_SCREEN_DATA_USAGE_STATS,
    GET_DAY_SCREEN_DATA_USAGE_STATS_FAIL,
    GET_PERIOD_SCREEN_DATA_USAGE_STATS_FAIL,
    GET_PERIOD_SCREEN_DATA_USAGE_STATS_SUCCESS,
    GET_SCREEN_STAT_RANKING_DETAILS,
    GET_SCREEN_STAT_RANKING_DETAILS_FAIL,
    GET_SCREENS_STATS_RANKING_FAIL,
    GET_SCREENS_STATS_RANKING_SUCCESS,
    GET_TWENTY_DAYS_USER_STATS,
    GET_USER_RANKING,
    GET_INTERNET_USAGE_PER_USER
} from "../constant";

const initial = {
  screenStatsError: true,
  dayScreenStat: null,
  periodScreenStatsError: true,
  periodScreenStatsErrorMsg: '',
  periodScreenStats: null,
  currentScreenDetails: null,
  totalGlobalBytesAmount: null,
  globalScreenStatsRecords: [],
  twentyDaysUserStats: [],
  userRanking: [],
  internetUsagePerUser: [],
  userRankingCount: 0
};
export const ScreenStatsReducer = (state = initial, action) => {
  switch (action.type) {
    case GET_DAY_SCREEN_DATA_USAGE_STATS:
      return {
        ...state,
        dayScreenStat: action.payload,
        screenStatsError: false
      };
    
    case GET_DAY_SCREEN_DATA_USAGE_STATS_FAIL:
      return {
        ...state,
        screenStatsError: true
      }
    case GET_PERIOD_SCREEN_DATA_USAGE_STATS_FAIL:
      return {
        ...state,
        periodScreenStatsError: true,
        periodScreenStatsErrorMsg: action.payload
      }

    case GET_PERIOD_SCREEN_DATA_USAGE_STATS_SUCCESS:
      return {
        ...state,
        periodScreenStats: action.payload,
        periodScreenStatsError: false
      }
    case GET_TWENTY_DAYS_USER_STATS: 
      return {
        ...state,
        twentyDaysUserStats: action.payload
      }
    case GET_USER_RANKING:
      return {
        ...state,
        userRanking: action.payload.ranking,
        userRankingCount: action.payload.rankingCount
      }
    case GET_INTERNET_USAGE_PER_USER:
      return {
        ...state,
        internetUsagePerUser: action.payload.ranking
      }
    case GET_SCREENS_STATS_RANKING_SUCCESS:
      return {
        ...state,
        totalGlobalBytesAmount: action.payload.totalGlobalBytesAmount,
        globalScreenStatsRecords: action.payload.globalScreenStatsRecords
      }
    case GET_SCREENS_STATS_RANKING_FAIL:
      console.log(action.payload)
      switch(action.payload) {
        case 'NoDate':
          toast.error("No date")
          break
        case 'InvalidDate':
          toast.error("Invalid date")
          break
        case 'InvalidPeriod':
          toast.error('Invalid period - You can download a maximum of 100 days of statistics')
          break
      }
      return {
        ...state
      }
    case GET_SCREEN_STAT_RANKING_DETAILS:
      return {
        ...state,
        currentScreenDetails: action.payload
      }
    case GET_SCREEN_STAT_RANKING_DETAILS_FAIL:
      console.log(action.payload)
      switch (action.payload){
        case 'InvalidDate':
          toast.error("Invalid date")
          break
        case 'InvalidPeriod':
          toast.error("Invalid period - You can download a maximum of 100 days of statistics")
          break
        case 'ServerErr':
          toast.error("Server error")
          break
      }
      return {
        ...state
      }
    default:
      return state;
  }
};
